var map = {
	"./en-US/en-US.json": [
		9232,
		232
	],
	"./fr-CI/fr-CI.json": [
		5480,
		480
	],
	"./fr-Fr/fr-Fr.json": [
		112,
		112
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8327;
module.exports = webpackAsyncContext;